import Component from "react-pure-render/component";
import React from "react";
import { addNotificationsForInvalidFields } from "../lib/validationWeb";
import Modal from "../components/modal.react";
import "./menu.css";
import InputCustom from "../components/inputCustom.react";
import InputWithError from "../components/inputWithError.react";
import Tooltip from "rc-tooltip";
import Select from "react-select";

export default class MenuItem extends Component {
  constructor(props) {
    super(props);
  }

  removeMenuItem = () => {
    const {
      actions,
      isRemoveModalVisible,
      notificationSystem,
      updateAction
    } = this.props;
    actions.removeMenuItem(isRemoveModalVisible).then(({ error, payload }) => {
      if (error) {
        addNotificationsForInvalidFields(payload, notificationSystem);
      } else {
        updateAction();
      }
    });
    actions.setIsRemoveMenuItemModalVisible(false);
  };

  closeRemoveMenuItemModal = () => {
    const { actions } = this.props;
    actions.setIsRemoveMenuItemModalVisible(false);
  };

  openRemoveMenuItemModal = () => {
    const { actions, menuItemUID } = this.props;
    actions.setIsRemoveMenuItemModalVisible(menuItemUID);
  };

  editMenuItem = () => {
    const {
      actions,
      isEditModalVisible,
      notificationSystem,
      menuItems,
      updateAction,
      menusTranslations
    } = this.props;
    let data = menuItems.get(isEditModalVisible).toJS();
    const dataObject = menusTranslations.getIn([
      data.menuTranslationUID,
      "dataObject"
    ]);
    dataObject.forEach(function(item, index) {
      if (data.uid === item.uid) {
        if (index === dataObject.length - 1) {
          data.beforeUID = null;
        } else {
          data.beforeUID = dataObject[index + 1].uid;
        }
      }
    });
    actions
      .updateMenuItem(data, isEditModalVisible)
      .then(({ error, payload }) => {
        if (error) {
          addNotificationsForInvalidFields(payload, notificationSystem);
        } else {
          updateAction();
        }
      });
    actions.setIsEditMenuItemModalVisible(false);
  };

  closeEditMenuItemModal = () => {
    const { actions } = this.props;
    actions.setIsEditMenuItemModalVisible(false);
  };

  openEditMenuItemModal = () => {
    const { actions, menuItemUID } = this.props;
    actions.setIsEditMenuItemModalVisible(menuItemUID);
  };

  addMenuItem = () => {
    const {
      actions,
      isEditModalVisible,
      notificationSystem,
      menusTranslations,
      form: { fields },
      uid,
      updateAction
    } = this.props;
    actions
      .createMenusTranslationMenuItems(uid, fields.toJS())
      .then(({ error, payload }) => {
        if (error) {
          addNotificationsForInvalidFields(payload, notificationSystem);
        } else {
          updateAction();
        }
      });
    actions.setIsAddMenuItemModalVisible(false);
  };

  closeAddMenuItemModal = () => {
    const { actions } = this.props;
    actions.setIsAddMenuItemModalVisible(false);
  };

  openAddMenuItemModal = () => {
    const { actions, menuItemUID } = this.props;
    actions.setIsAddMenuItemModalVisible(menuItemUID);
  };

  onEditResourceUrlSelect = (value, options) => {
    const { actions, menuItemUID } = this.props;
    actions.setEntityField(
      "menuItems",
      menuItemUID,
      "value",
      `page:${options[0].pageUID}`
    );
  };

  onEditFieldTypeSelect = value => {
    const { actions, menuItemUID } = this.props;
    actions.setEntityField("menuItems", menuItemUID, "fieldType", value);
  };

  onAddResourceUrlSelect = (value, options) => {
    const { actions, menuItemUID } = this.props;
    actions.setFormField(
      "menusTranslations",
      "createMenusTranslationMenuItems",
      "value",
      `page:${options[0].pageUID}`
    );
  };

  onAddFieldTypeSelect = value => {
    const { actions, menuItemUID } = this.props;
    actions.setFormField(
      "menusTranslations",
      "createMenusTranslationMenuItems",
      "fieldType",
      value
    );
  };

  render() {
    const {
      uid,
      defaultLocale,
      pages,
      form,
      menuItems,
      menuItemUID,
      isEditModalVisible,
      isRemoveModalVisible,
      isAddModalVisible,
      isAddPlaceholdersVisible,
      actions
    } = this.props;

    const editMenuItemProps = {
      actions: actions,
      feature: "menuItems",
      uid: menuItemUID,
      entity: menuItems.get(menuItemUID)
    };

    const addMenuItemProps = {
      actions: actions,
      feature: "menusTranslations",
      uid: menuItemUID,
      form: form,
      formName: "createMenusTranslationMenuItems",
      validateFormField: actions.validateFormFieldMenusTranslations
    };

    let resourceUrlSelectOptions = [];
    let value = "";
    if (pages) {
      pages.forEach(function(page, index) {
        resourceUrlSelectOptions.push({
          value: page.getIn(["pageTranslations", defaultLocale, "slug"]),
          pageUID: page.getIn(["pageTranslations", defaultLocale, "uid"]),
          label: page.getIn(["pageTranslations", defaultLocale, "name"])
        });
        if (
          `/${page.getIn(["pageTranslations", defaultLocale, "slug"])}` ===
          menuItems.getIn([menuItemUID, "value"])
        ) {
          value = page.getIn(["pageTranslations", defaultLocale, "name"]);
        } else if (
          `page:${page.getIn(["pageTranslations", defaultLocale, "uid"])}` ===
          menuItems.getIn([menuItemUID, "value"])
        ) {
          value = page.getIn(["pageTranslations", defaultLocale, "name"]);
        }
      });
    }

    const fieldTypeSelectOptions = [
      {
        value: "resourceURL",
        label: "Link wewnętrzny"
      },
      {
        value: "rawURL",
        label: "Link zewnętrzny"
      }
    ];

    return (
      <div
        className="menu-item-container"
        style={{ marginLeft: menuItems.getIn([menuItemUID, "depth"]) * 20 }}
      >
        {isAddPlaceholdersVisible === menuItemUID && (
          <div className="row">
            <div
              className="menu-item-placeholder"
              onClick={this.openAddMenuItemModal}
            >
              Dodaj nowy element powyżej
            </div>
          </div>
        )}
        <div className="row middle-xs menu-item">
          <div className="col-xs-6">
            {menuItems.getIn([menuItemUID, "name"])}
          </div>
          <div className="col-xs-6">
            <Tooltip
              placement="bottom"
              trigger={["click", "hover"]}
              overlay={
                <div className="popover">
                  <a onTouchTap={this.openAddMenuItemModal}>
                    dodaj element poniżej
                  </a>
                  <br />
                  <a onTouchTap={this.openEditMenuItemModal}>edytuj</a>
                  <br />
                  <a onTouchTap={this.openRemoveMenuItemModal}>usuń</a>
                </div>
              }
              getTooltipContainer={() => document.getElementById("wrapper")}
            >
              <div className="icon-table link" />
            </Tooltip>
          </div>
        </div>
        {isAddPlaceholdersVisible === menuItemUID && (
          <div className="row">
            <div
              className="menu-item-placeholder children"
              onClick={this.openAddMenuItemModal}
            >
              Dodaj nowy element - dziecko
            </div>
          </div>
        )}
        {isAddPlaceholdersVisible === menuItemUID && (
          <div className="row">
            <div
              className="menu-item-placeholder"
              onClick={this.openAddMenuItemModal}
            >
              Dodaj nowy element poniżej
            </div>
          </div>
        )}

        {isEditModalVisible === menuItemUID && (
          <Modal
            closeModalAction={this.closeEditMenuItemModal}
            enterAction={this.editMenuItem}
            handleKeyDownEvent={true}
          >
            <div className="row center-xs middle-xs">
              <h3 className="col-xs-12">Edytuj element menu</h3>
              <label htmlFor="name" className="col-xs-12 col-sm-4">
                Nazwa:
              </label>
              <div className="col-xs-12 col-sm-8">
                <InputCustom field={["name"]} {...editMenuItemProps} />
              </div>
              <label htmlFor="value" className="col-xs-12 col-sm-4">
                Wartość:
              </label>
              <div className="col-xs-12 col-sm-8">
                {menuItems.getIn([menuItemUID, "fieldType"]) ===
                "resourceURL" ? (
                  <Select
                    name="select-resource-url"
                    value={value}
                    options={resourceUrlSelectOptions}
                    onChange={this.onEditResourceUrlSelect}
                    clearable={false}
                  />
                ) : (
                  <InputCustom field={["value"]} {...editMenuItemProps} />
                )}
              </div>
              <label htmlFor="description" className="col-xs-12 col-sm-4">
                Opis:
              </label>
              <div className="col-xs-12 col-sm-8">
                <InputCustom field={["description"]} {...editMenuItemProps} />
              </div>
              <label htmlFor="fieldType" className="col-xs-12 col-sm-4">
                Typ pola:
              </label>
              <div className="col-xs-12 col-sm-8">
                <Select
                  name="select-field-type"
                  value={menuItems.getIn([menuItemUID, "fieldType"])}
                  options={fieldTypeSelectOptions}
                  onChange={this.onEditFieldTypeSelect}
                  clearable={false}
                />
              </div>
              <div className="col-xs-12">
                <button className="success" onClick={this.editMenuItem}>
                  Opublikuj zmiany
                </button>
                <button className="info" onClick={this.closeEditMenuItemModal}>
                  Anuluj
                </button>
              </div>
            </div>
          </Modal>
        )}

        {isRemoveModalVisible === menuItemUID && (
          <Modal
            closeModalAction={this.closeRemoveMenuItemModal}
            enterAction={this.removeMenuItem}
            handleKeyDownEvent={true}
          >
            <div className="row center-xs middle-xs">
              <h3 className="col-xs-12">Potwierdź usunięcie</h3>
              <div className="col-xs-12 media-item" />
              <p>
                Czy napewno usunąć {menuItems.getIn([menuItemUID, "name"])} ?
              </p>
              <div className="col-xs-12">
                <button className="error" onClick={this.removeMenuItem}>
                  Usuń
                </button>
                <button
                  className="info"
                  onClick={this.closeRemoveMenuItemModal}
                >
                  Anuluj
                </button>
              </div>
            </div>
          </Modal>
        )}

        {isAddModalVisible === menuItemUID && (
          <Modal
            closeModalAction={this.closeAddMenuItemModal}
            enterAction={this.addMenuItem}
            handleKeyDownEvent={true}
          >
            <div className="row center-xs middle-xs">
              <h3 className="col-xs-12">Edytuj element menu</h3>
              <label htmlFor="name" className="col-xs-12 col-sm-4">
                Nazwa:
              </label>
              <div className="col-xs-12 col-sm-8">
                <InputWithError field="name" {...addMenuItemProps} />
              </div>
              <label htmlFor="value" className="col-xs-12 col-sm-4">
                Wartość:
              </label>
              <div className="col-xs-12 col-sm-8">
                {form.getIn(["fields", "fieldType"]) === "resourceURL" ? (
                  <Select
                    name="select-resource-url"
                    value={value}
                    options={resourceUrlSelectOptions}
                    onChange={this.onAddResourceUrlSelect}
                    clearable={false}
                  />
                ) : (
                  <InputWithError field="value" {...addMenuItemProps} />
                )}
              </div>
              <label htmlFor="description" className="col-xs-12 col-sm-4">
                Opis:
              </label>
              <div className="col-xs-12 col-sm-8">
                <InputWithError field="description" {...addMenuItemProps} />
              </div>
              <label htmlFor="description" className="col-xs-12 col-sm-4">
                Typ pola:
              </label>
              <div className="col-xs-12 col-sm-8">
                <Select
                  name="select-field-type"
                  value={form.getIn(["fields", "fieldType"])}
                  options={fieldTypeSelectOptions}
                  onChange={this.onAddFieldTypeSelect}
                  clearable={false}
                />
              </div>
              <div className="col-xs-12">
                <button className="success" onClick={this.addMenuItem}>
                  Dodaj
                </button>
                <button className="info" onClick={this.closeAddMenuItemModal}>
                  Anuluj
                </button>
              </div>
            </div>
          </Modal>
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/browser/menu/menuItem.react.js